<template>
  <div>
    <Head :active="1"/>
    <szhimg
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
        />
        <div class="platform-advantages">
     
        <div class="advantages-container">
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame21.png" alt="" />
            </div>
            <div class="icon-wrapperss"> 
            <h3>全球运营</h3>
            <ul>
              <li>集成全球180+运营商，统一对接平台全球化部署能力，智连世界；</li>
              <li>提供海外数据安全法规等合规建议；</li>
              <li>全球流量运营；</li>
            </ul>
          </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame22.png" alt="" />
            </div>
            <div class="icon-wrapperss"> 
            <h3>eSIM</h3>
            <ul>
              <li>兼容标准化运营商eSIM框架，与运营商快速完成平台对接；</li>
              <li>自主研发SM-DP+、LPA设备自由切换；</li>
              <li>不同类型数据连接不同的网络；</li>
            </ul>
          </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame23.png" alt="" />
            </div>
            <div class="icon-wrapperss"> 
            <h3>VSIM</h3>
            <ul>
              <li>无需硬件修改，降低故障修复成本；</li>
              <li>无需实体卡，减少卡本费；</li>
              <li>灵活切换网络码号资源，降低流量成本；</li>
              <li>提供集中化的远程管理能力；</li>
            </ul>
          </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame24.png" alt="" />
            </div>
            <div class="icon-wrapperss"> 
            <h3>一卡三芯</h3>
            <ul>
              <li>自动切换运营商，时刻在线；</li>
              <li>支持功能分离与统一管理，简化管理流程；</li>
            </ul>
          </div>  
          </div>
        </div>
      </div>
      <div class="foter">
        <Footer/>
      </div>
  </div>
</template>

<script>
import Head from '@/components/head.vue'
import szhimg from "../quanqiu.vue"; 
import Footer from '@/components/footer2.vue'
export default {
  name: 'globalconnection',
  components: {
    Head,
    szhimg,
    Footer
  },
  data() {
    return {
      isShow: false,
      bannerData: [
        {
          title: "全球连接",
          content:
            "云百应用eSIM、vSIM及一卡三芯技术给客户提供全球网络连接服务，保障客户出海业务顺利开展，赋能客户快速实现全球化无缝部署",
          button: "获取专属方案",
          banner: "digital_bg3",
        },
      ],
    };
  },
}
</script>
<style lang="scss" scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-header {
  height: 80px !important;
  padding: 0;
  position: relative;
}

.car-network-section {
  img {
    width: 100%;
    height: 335px;
  }
}
.car-network-sections {
  img {
    width: 100%;
    height: 869px;
  }
}
.car-network-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 60px;
  padding: 0 20px;
}

.map-side {
  flex: 1;
  position: relative;
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-side {
  flex: 1;
  padding-top: 20px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
}

.platform-advantages {
  padding: 80px 0;
  max-width: 1400px;
  margin: 0 auto;

  .section-title {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 60px;
    color: #333;
    font-family: PingFang SC, PingFang SC-500;
  }

  .advantages-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    padding: 0 20px;
  }

  .advantage-item {
    padding: 30px 20px;
    border-radius: 8px;
    padding-bottom: 50px;
    transition: all 0.3s ease;
    cursor: pointer;
    text-align: center;
    border: 1px solid transparent;
    height: 240px;
    border: 0.5px solid #E5E7EB;
    &:hover {
      border-color: #4080ff;
      // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .icon-wrapper {
      width: 60px;
      height: 60px;
      margin: 0 auto 20px;
      // background: #f5f7fa;
      border-radius: 8px;
    }

    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      color: #666;
      margin: 0;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}

@media (max-width: 1024px) {
  .car-network-content {
    flex-direction: column;
    gap: 30px;
  }

  .text-side {
    padding-top: 0;
  }

  .platform-advantages {
    .advantages-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 640px) {
  .platform-advantages {
    padding: 40px 0;

    .advantages-container {
      grid-template-columns: 1fr;
    }

    .section-title {
      font-size: 24px;
      margin-bottom: 40px;
    }
  }
}
.icon-wrapper {
  text-align: center;
  img {
  // margin-right: 20px;
  margin-left: -10px;
    width: 80px;
    height: 80px;
  }
}
.bigimg {
  img {
    width: 100%;
    height: 935px;
  }
}
.foter {
  margin-top: 60px;
}
.CarNetwork-header{
  height: 640px;
}
.icon-wrapperss{
  text-align: center;
  width: 244px;
  
  h3{
    padding-bottom: 5px;
    padding-top: 20px;
    height: 15px;
    font-family: PingFang SC, PingFang SC-500;
  }
  ul {
    display: inline-block;
    text-align: left;
    margin: 0 auto;
    padding-left: 20px;


  }
  li {
    font-size: 14px;
    line-height: 1.6;
    color: #666;
    margin-bottom: 4px;
    list-style-type: disc;
    font-weight: 200;
  }
}

</style>